import React from "react";
import {Button, Result} from "antd";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

const UnauthorizedPage = () => {
    const {t} = useTranslation("common");
    const navigate = useNavigate();

    const handleBackHome = () => {
        navigate("/");
    }

    return (
        <div className="w-full h-screen flex items-center justify-center">
            <Result
                status="403"
                title="403"
                subTitle={t("unauthorized_message")}
                extra={<Button type="primary" onClick={handleBackHome}>{t("back_home")}</Button>}
            />
        </div>
    );
};

export default UnauthorizedPage;